import { DropdownIcon } from "app/components/Icons";
import ProfileAvatar from "app/components/ProfileAvatar";
import MemberSelection from "app/containers/Features/components/MemberSelection";
import {
  filterActiveTeamMembers,
  getMembersByIds,
} from "app/containers/Features/components/MemberSelection/helper";
import { selectProjectMemberList } from "app/containers/Features/components/MemberSelection/redux/selector";
import {
  IMemberList
} from "app/containers/Features/components/MemberSelection/types";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IAvatar } from "../../../TeamSettings/container/MySetting/types";
import { actions } from "../../redux/slice";

interface Props {
  selectedId: string;
}
const ScrumMaster: React.FC<Props> = ({ selectedId }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const members = useSelector(selectProjectMemberList);
  const activeMember = filterActiveTeamMembers(members);
  const owner = useMemo(() => {
    return getMembersByIds(members, selectedId)[0];
  }, [members, selectedId]);

  const handleUpdateMember = (member: IMemberList) => {
    dispatch(
      actions.updateFormValue({ key: "scrumMasterId", value: member._id })
    );
  };

  return (
    <div className="flex flex-col gap-[6px] group">
      <label className="text-xs font-normal text-secondary">Scrum master</label>
      <MemberSelection
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        trigger={
          <div
            className={`flex items-center gap-[8px] flex-row border rounded-[4px] py-[16px] px-[10px] h-[48px]  ${
              open ? "border-secondary !border-[1px]" : "border-[#E9ECF2]"
            } `}
          >
            <button className="flex items-center justify-between text-sm rounded w-full text-gray-700 leading-[21px] focus:outline-none placeholder:text-[#BDC0C3] placeholder:font-normal placeholder:text-sm placeholder:leading-[21px]">
              {selectedId ? (
                <div className="flex items-center gap-1 w-full truncate ">
                  <ProfileAvatar
                    name={owner?.name as string}
                    avatar={owner?.avatar as IAvatar}
                    circleClassName=" w-6 h-6 "
                  />
                  <span className=" text-sm font-normal text-black truncate ">
                    {owner?.name as string}
                  </span>
                </div>
              ) : (
                <span className="font-normal text-sm leading-[21px] text-[#BDC0C3]">
                  Choose scrum master
                </span>
              )}
              <div
                className={`size-[16px] min-w-[16px] transition-transform duration-300 ease-in-out ${
                  open ? "rotate-180" : ""
                }`}
              >
                <DropdownIcon size={16} />
              </div>
            </button>
          </div>
        }
        selectedValue={selectedId}
        updateValue={handleUpdateMember}
        options={activeMember}
        isFullWidth
        searchPlaceholder="Search by member name..."
        hideRole
        hideSearchIcon
      />
    </div>
  );
};

export default ScrumMaster;
